/** @format */

/* eslint-disable */
import React from 'react'
import BreadCrumb from '../../../../../../Components/BreadCrumb/Index'
import localize from '../../../../../../Global/Localize'
import ListRefundBatches from '../Partials/ListRefundBatches'

const BatchVerification = () => {
  return (
    <>
      <BreadCrumb
        tree={[
          localize('refundBatches'),
          localize('settlement'),
          localize('verification'),
        ]}
      />
      <div className="row">
        <ListRefundBatches refundBatchMode={'verify'} />
      </div>
    </>
  )
}

export default BatchVerification
